import { useGLTF } from "@react-three/drei";
import * as THREE from 'three'
const stdmat = new THREE.MeshLambertMaterial({
  color: new THREE.Color( 0.06, 0.02, 0.003 ),
  reflectivity: 0
})

export function Bench(props) {
  const { nodes } = useGLTF("/models/bench.glb");
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube.geometry}
        material={stdmat}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube001.geometry}
        material={stdmat}
      />
    </group>
  );
}

useGLTF.preload("/models/bench.glb");